/* =============================================================================
   IRONHOLD - FICHES ACCESSOIRES (acc-v1.1, 6 octobre 2026 : bloc moto identique aux fiches guidons)
   Meme formule que les fiches guidons :
     1. le client choisit sa moto (marque, annee, modele) ;
     2. la fiche dit si l article va sur sa moto ;
     3. les choix imposes par la moto (TYPE de l engine guard, type du sissy bar,
        type du support de carenage) sont faits tout seuls et caches ;
     4. "Ta moto a aussi besoin" : piece obligatoire (support de carenage RG) ;
     5. "Si tu veux" : piece optionnelle (soft lowers sur l engine guard) ;
     6. au panier : la moto et une reference sur chaque ligne.
   Donnees : window.IH_ACC_DATA (ih-accessoires-data-v1.js, genere du classeur).
   Fichier 100 % ASCII : accents en \uXXXX.
   ============================================================================= */
(function () {
  if (window.IH_ACC) return;
  var D = window.IH_ACC_DATA;
  if (!D) return;

  var VERSION = 'acc-v1.1';
  var FR = String((window.Shopify && Shopify.locale) || document.documentElement.lang || 'en').slice(0, 2).toLowerCase() === 'fr';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var T = FR ? {
    title: 'Choisis ta moto', make: 'Marque', year: 'Ann\u00e9e', model: 'Mod\u00e8le',
    pickMake: 'Choisis la marque', pickYear: 'Choisis l\'ann\u00e9e', pickModel: 'Choisis le mod\u00e8le',
    firstMake: 'Choisis d\'abord la marque', firstYear: 'Choisis d\'abord l\'ann\u00e9e', ok: 'Compatible avec ta moto', no: 'Cet article ne va pas sur ta moto.',
    noMore: 'Les mod\u00e8les compatibles sont indiqu\u00e9s dans la description. \u00c9cris-nous si tu as un doute.',
    need: 'Choisis ta moto pour ajouter cet article au panier.', reqT: 'TA MOTO A AUSSI BESOIN',
    reqS: 'Sur ta moto, cet article ne s\u2019installe pas sans la pi\u00e8ce ci-dessous.',
    optT: 'SI TU VEUX', add: '+ AJOUTER', added: '\u2713 AJOUT\u00c9', total: 'TOTAL DES PI\u00c8CES',
    warn: 'Sans cette pi\u00e8ce, l\u2019article ne peut pas \u00eatre install\u00e9 sur ta moto.',
    note: 'Les pi\u00e8ces ajout\u00e9es vont dans ton panier avec l\u2019article, sur la m\u00eame commande.',
    adding: 'AJOUT\u2026', err: 'L\u2019ajout au panier a \u00e9chou\u00e9. R\u00e9essaie.', unav: 'NON DISPONIBLE',
    bikeP: 'Motorcycle'
  } : {
    title: 'Select your motorcycle', make: 'Make', year: 'Year', model: 'Model',
    pickMake: 'Select make', pickYear: 'Select year', pickModel: 'Select model',
    firstMake: 'Select make first', firstYear: 'Select year first', ok: 'Fits your motorcycle', no: 'This item does not fit your motorcycle.',
    noMore: 'Compatible models are listed in the description. Contact us if in doubt.',
    need: 'Select your motorcycle to add this item to your cart.', reqT: 'YOUR MOTORCYCLE ALSO NEEDS',
    reqS: 'On your motorcycle, this item cannot be installed without the part below.',
    optT: 'IF YOU WANT', add: '+ ADD', added: '\u2713 ADDED', total: 'Parts total',
    warn: 'Without this part, the item cannot be installed on your motorcycle.',
    note: 'Added parts go into your cart with the item, on the same order.',
    adding: 'ADDING\u2026', err: 'Could not add to cart. Please try again.', unav: 'UNAVAILABLE',
    bikeP: 'Motorcycle'
  };

  /* ---------- utilitaires ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function cur() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD'; }
  function money(cents) {
    var n = (Number(cents) || 0) / 100, c = cur();
    var s = n.toFixed(2);
    if (FR) { s = s.replace('.', ','); s = s.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0'); return s + '\u00a0$\u00a0' + c; }
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' ' + c;
  }
  function handleOf() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function groupFor(h, model, year) {
    var p = D.P[h]; if (!p) return null;
    var r = p.f[model]; if (!r) return null;
    for (var i = 0; i < r.length; i++) if (year >= r[i][0] && year <= r[i][1]) return p.g[r[i][2]];
    return null;
  }
  function reqFor(h, model, year) {
    var q = D.req && D.req[h]; if (!q) return null;
    var r = q.m[model]; if (!r) return null;
    for (var i = 0; i < r.length; i++) if (year >= r[i][0] && year <= r[i][1]) return { h: q.h, sku: r[i][2] };
    return null;
  }
  var REF_KEY = 'ih_acc_ref';
  function newRef() {
    var d = new Date(), p = function (n) { return (n < 10 ? '0' : '') + n; };
    return 'ACC-' + String(d.getFullYear()).slice(2) + p(d.getMonth() + 1) + p(d.getDate()) + '-' + String(Math.floor(1000 + Math.random() * 9000));
  }
  var prodCache = {};
  function getProduct(h) {
    if (!prodCache[h]) prodCache[h] = fetch(ROOT.replace(/\/?$/, '/') + 'products/' + h + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return prodCache[h];
  }

  /* ---------- la page ---------- */
  var H = handleOf();
  if (!D.P[H]) return;
  var radios = $('variant-radios, variant-selects');
  var form = $$('form[action*="/cart/add"]').filter(function (f) { return f.querySelector('[name="add"]'); })[0];
  if (!form) return;
  var addBtn = form.querySelector('[name="add"]');
  var variants = [];
  try { variants = JSON.parse((radios && radios.querySelector('script[type="application/json"]') || {}).textContent || '[]'); } catch (e) { variants = []; }
  var optNames = $$('fieldset legend', radios || document).map(function (l) { return l.textContent.trim(); });
  var hidden = (D.hide && D.hide[H]) || [];
  var hiddenIdx = hidden.map(function (n) { return optNames.indexOf(n); }).filter(function (i) { return i >= 0; });

  var state = { make: '', year: 0, model: '', allowed: null, req: null, picks: {} };
  try { state.ref = sessionStorage.getItem(REF_KEY) || ''; } catch (e) { state.ref = ''; }
  if (!state.ref) { state.ref = newRef(); try { sessionStorage.setItem(REF_KEY, state.ref); } catch (e) {} }

  /* cacher les choix imposes par la moto */
  $$('fieldset', radios || document).forEach(function (fs) {
    var lg = fs.querySelector('legend');
    if (lg && hidden.indexOf(lg.textContent.trim()) >= 0) { fs.style.display = 'none'; fs.setAttribute('data-ih-acc-hidden', '1'); }
  });

  /* ---------- le bloc moto ---------- */
  var css = el('style');
  css.textContent =
    /* bloc moto : memes regles que #ih-fitment des fiches guidons */
    '.ih-acc{margin:18px 0;max-width:440px}' +
    '.ih-acc__t{font-weight:bold;text-transform:uppercase;letter-spacing:1px;margin:0 0 10px}' +
    '.ih-acc__l{display:block;margin:0 0 4px;font-size:13px;opacity:.8}' +
    '.ih-acc select{width:100%;padding:10px;margin:0 0 14px;border-radius:6px;box-sizing:border-box}' +
    '.ih-acc__v{border-radius:8px;padding:12px 14px;font-size:14px;line-height:1.5;margin:0 0 16px}' +
    '.ih-acc__v--ok{background:rgba(46,160,67,.15);border:1px solid #2ea043}' +
    '.ih-acc__v--no{background:rgba(224,73,47,.12);border:1px solid #e0492f}' +
    '.ih-acc__need{margin:0 0 4px;font-size:13px;color:#FF671D}' +
    '.ih-acc__box{margin:0 0 16px;border:1.5px solid #FF671D;border-radius:8px;padding:12px 14px}' +
    '.ih-acc__box--opt{border-color:rgba(244,240,230,.35)}' +
    '.ih-acc__bt{font-size:13px;letter-spacing:1px;font-weight:bold;text-transform:uppercase;color:#FF671D;margin:0 0 4px}' +
    '.ih-acc__box--opt .ih-acc__bt{color:inherit}' +
    '.ih-acc__bs{font-size:13px;opacity:.8;margin:0 0 10px;line-height:1.5}' +
    '.ih-acc__row{display:flex;gap:12px;align-items:center;padding:8px 0;border-top:1px solid rgba(244,240,230,.15)}' +
    '.ih-acc__img{width:56px;height:56px;object-fit:contain;background:#fff;flex:0 0 56px;border-radius:4px}' +
    '.ih-acc__info{flex:1;min-width:0;font-size:13px;line-height:18px}' +
    '.ih-acc__sku{color:#999;font-size:12px}.ih-acc__pr{font-weight:700}' +
    '.ih-acc__btn{flex:0 0 auto;background:transparent;border:1.5px solid #FF671D;border-radius:4px;color:#FF671D;padding:8px 12px;font-size:12px;font-weight:bold;letter-spacing:1px;cursor:pointer}' +
    '.ih-acc__btn[aria-pressed="true"]{background:#FF671D;color:#fff}' +
    '.ih-acc__btn:disabled{opacity:.5;cursor:default}' +
    '.ih-acc__warn{display:block;color:#ff9b8f;font-size:12px;margin-top:6px}' +
    '.ih-acc__tot{display:flex;justify-content:space-between;border-top:1px solid rgba(244,240,230,.15);padding-top:8px;margin-top:4px;font-size:13px}' +
    '.ih-acc__note{font-size:11px;color:#999;margin-top:6px}' +
    'html[data-ih-acc-lock] product-form .product-form__buttons,html[data-ih-acc-lock] .product-form__buttons{opacity:.45;pointer-events:none}';
  document.head.appendChild(css);

  var box = el('div', 'ih-acc'); box.id = 'ih-acc';
  box.appendChild(el('p', 'ih-acc__t', T.title));
  function sel(label, id) { var l = el('label', 'ih-acc__l', label); l.setAttribute('for', id); var s = el('select'); s.id = id; box.appendChild(l); box.appendChild(s); return s; }
  var sMake = sel(T.make, 'ih-acc-make'), sYear = sel(T.year, 'ih-acc-year'), sModel = sel(T.model, 'ih-acc-model');
  var verdict = el('div', 'ih-acc__v'); verdict.hidden = true; box.appendChild(verdict);
  var need = el('p', 'ih-acc__need', T.need); box.appendChild(need);
  var reqBox = el('div', 'ih-acc__box'); reqBox.hidden = true; box.appendChild(reqBox);
  var optBox = el('div', 'ih-acc__box ih-acc__box--opt'); optBox.hidden = true; box.appendChild(optBox);

  /* proprietes de panier (attachees au formulaire du theme) */
  function hiddenProp(name) {
    var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + name + ']'; i.disabled = true; form.appendChild(i); return i;
  }
  var pBike = hiddenProp(T.bikeP), pRef = hiddenProp('Reference');

  function opts(s, list, ph, show) {
    s.innerHTML = ''; var o = el('option', null, ph); o.value = ''; s.appendChild(o);
    list.forEach(function (v) { var x = el('option', null, show ? show(String(v)) : String(v)); x.value = String(v); s.appendChild(x); });
  }
  /* HARLEY-DAVIDSON -> Harley-Davidson, comme sur les fiches guidons */
  function nomMarque(v) { return v.toLowerCase().replace(/(^|[\s-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); }
  var makes = Object.keys(D.B).sort();
  opts(sMake, makes, T.pickMake, nomMarque);
  opts(sYear, [], T.firstMake); sYear.disabled = true;
  opts(sModel, [], T.firstYear); sModel.disabled = true;

  function yearsOf(mk) {
    var s = {}, b = D.B[mk] || {};
    Object.keys(b).forEach(function (m) { b[m].forEach(function (y) { s[y] = 1; }); });
    return Object.keys(s).map(Number).sort(function (a, b) { return b - a; });
  }
  function modelsOf(mk, y) {
    var b = D.B[mk] || {};
    return Object.keys(b).filter(function (m) { return b[m].indexOf(y) >= 0; }).sort();
  }
  function fillYears() {
    var mk = sMake.value;
    if (!mk) { opts(sYear, [], T.firstMake); sYear.disabled = true; }
    else { opts(sYear, yearsOf(mk), T.pickYear); sYear.disabled = false; }
    fillModels();
  }
  function fillModels() {
    var y = Number(sYear.value);
    if (!y) { opts(sModel, [], T.firstYear); sModel.disabled = true; }
    else { opts(sModel, modelsOf(sMake.value, y), T.pickModel); sModel.disabled = false; }
    apply();
  }

  /* ---------- choisir la variante permise par la moto ---------- */
  function currentVariantId() { var i = form.querySelector('input[name="id"]'); return i ? Number(i.value) : 0; }
  function variantById(id) { for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i]; return null; }
  function syncVariant() {
    if (!state.allowed || !hiddenIdx.length || !radios) return;
    var v = variantById(currentVariantId()) || variants[0]; if (!v) return;
    if (state.allowed.indexOf(v.sku) >= 0) return;
    var vis = function (x) { for (var k = 0; k < x.options.length; k++) if (hiddenIdx.indexOf(k) < 0 && x.options[k] !== v.options[k]) return false; return true; };
    var target = null;
    for (var i = 0; i < variants.length; i++) if (state.allowed.indexOf(variants[i].sku) >= 0 && vis(variants[i])) { target = variants[i]; break; }
    if (!target) for (var j = 0; j < variants.length; j++) if (state.allowed.indexOf(variants[j].sku) >= 0) { target = variants[j]; break; }
    if (!target) return;
    target.options.forEach(function (val, k) {
      var name = optNames[k];
      var inp = $$('input[type="radio"]', radios).filter(function (r) { return r.name === name && r.value === val; })[0];
      if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
      var s = $$('select', radios).filter(function (x) { return x.name === 'options[' + name + ']'; })[0];
      if (s && s.value !== val) { s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }

  /* ---------- encadres des pieces ---------- */
  function partRow(container, prod, variant, kind) {
    var row = el('div', 'ih-acc__row');
    var img = el('img', 'ih-acc__img'); img.alt = '';
    var src = (variant.featured_image && variant.featured_image.src) || prod.featured_image || '';
    if (src) img.src = (src.indexOf('//') === 0 ? 'https:' : '') + src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
    var info = el('div', 'ih-acc__info');
    info.appendChild(el('div', null, prod.title + (variant.title && variant.title !== 'Default Title' ? ' \u2014 ' + variant.title : '')));
    info.appendChild(el('div', 'ih-acc__sku', variant.sku || ''));
    info.appendChild(el('div', 'ih-acc__pr', money(variant.price)));
    var b = el('button', 'ih-acc__btn'); b.type = 'button';
    var on = !!state.picks[variant.id];
    b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.textContent = variant.available ? (on ? T.added : T.add) : T.unav;
    if (!variant.available) b.disabled = true;
    b.addEventListener('click', function () {
      if (state.picks[variant.id]) delete state.picks[variant.id]; else state.picks[variant.id] = { id: variant.id, kind: kind, price: variant.price };
      renderParts();
    });
    row.appendChild(img); row.appendChild(info); row.appendChild(b);
    if (kind === 'req' && !on) info.appendChild(el('span', 'ih-acc__warn', T.warn));
    container.appendChild(row);
  }
  var renderToken = 0;
  function renderParts() {
    var tok = ++renderToken;
    reqBox.innerHTML = ''; optBox.innerHTML = ''; reqBox.hidden = true; optBox.hidden = true;
    if (!state.allowed) return;
    var jobs = [];
    if (state.req) jobs.push(getProduct(state.req.h).then(function (p) { return { kind: 'req', p: p, sku: state.req.sku }; }));
    ((D.opt && D.opt[H]) || []).forEach(function (o) {
      var g = groupFor(o.h, state.model, state.year);
      if (g) jobs.push(getProduct(o.h).then(function (p) { return { kind: 'opt', p: p, sku: g[0] }; }));
    });
    Promise.all(jobs).then(function (res) {
      if (tok !== renderToken) return;
      var keep = {};
      res.forEach(function (r) {
        if (!r.p) return;
        var v = r.p.variants.filter(function (x) { return x.sku === r.sku; })[0]; if (!v) return;
        keep[v.id] = 1;
        var c = r.kind === 'req' ? reqBox : optBox;
        if (!c.childNodes.length) {
          c.appendChild(el('p', 'ih-acc__bt', r.kind === 'req' ? T.reqT : T.optT));
          if (r.kind === 'req') c.appendChild(el('p', 'ih-acc__bs', T.reqS));
        }
        partRow(c, r.p, v, r.kind); c.hidden = false;
      });
      Object.keys(state.picks).forEach(function (id) { if (!keep[id]) delete state.picks[id]; });
      var ids = Object.keys(state.picks);
      if (ids.length) {
        var tot = ids.reduce(function (s, id) { return s + Number(state.picks[id].price || 0); }, 0);
        var host = reqBox.hidden ? optBox : reqBox;
        var t = el('div', 'ih-acc__tot'); t.appendChild(el('span', null, T.total)); t.appendChild(el('strong', null, money(tot)));
        host.appendChild(t); host.appendChild(el('p', 'ih-acc__note', T.note));
      }
    });
  }

  /* ---------- verdict et verrou ---------- */
  function lock(on) {
    if (on) document.documentElement.setAttribute('data-ih-acc-lock', '1'); else document.documentElement.removeAttribute('data-ih-acc-lock');
  }
  function apply() {
    state.make = sMake.value; state.year = Number(sYear.value) || 0; state.model = sModel.value;
    var ready = state.make && state.year && state.model;
    state.allowed = ready ? groupFor(H, state.model, state.year) : null;
    state.req = state.allowed ? reqFor(H, state.model, state.year) : null;
    verdict.hidden = !ready;
    if (ready) {
      var bike = state.year + ' ' + state.model;
      verdict.className = 'ih-acc__v ' + (state.allowed ? 'ih-acc__v--ok' : 'ih-acc__v--no');
      verdict.textContent = state.allowed ? '\u2713 ' + T.ok + ' : ' + bike : '\u2717 ' + T.no + ' ' + T.noMore;
      pBike.value = bike; pRef.value = state.ref;
    }
    pBike.disabled = pRef.disabled = !state.allowed;
    need.hidden = !!state.allowed;
    lock(!state.allowed);
    syncVariant();
    renderParts();
    try { sessionStorage.setItem('ih_acc_bike', JSON.stringify({ m: state.make, y: state.year, d: state.model })); } catch (e) {}
  }
  sMake.addEventListener('change', fillYears);
  sYear.addEventListener('change', fillModels);
  sModel.addEventListener('change', apply);
  if (radios) radios.addEventListener('change', function () { setTimeout(syncVariant, 0); });

  /* ---------- envoi au panier ---------- */
  form.addEventListener('submit', function (e) {
    if (!state.allowed) { e.preventDefault(); e.stopImmediatePropagation(); need.hidden = false; box.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    var ids = Object.keys(state.picks); if (!ids.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var fid = form.getAttribute('id') || '';
    var q = Number((fid && document.querySelector('input[name="quantity"][form="' + fid + '"]') || form.querySelector('input[name="quantity"]') || { value: 1 }).value) || 1;
    var props = {}; props[T.bikeP] = pBike.value; props.Reference = state.ref;
    var items = [{ id: currentVariantId(), quantity: q, properties: props }];
    ids.forEach(function (id) { var pp = {}; for (var k in props) pp[k] = props[k]; items.push({ id: Number(id), quantity: q, properties: pp }); });
    if (addBtn) { addBtn.setAttribute('aria-disabled', 'true'); addBtn.classList.add('loading'); }
    fetch(ROOT.replace(/\/?$/, '/') + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); location.href = ROOT.replace(/\/?$/, '/') + 'cart'; })
      .catch(function () { if (addBtn) { addBtn.removeAttribute('aria-disabled'); addBtn.classList.remove('loading'); } alert(T.err); });
  }, true);

  /* ---------- placement : juste avant la quantite / le bouton ---------- */
  var anchor = $('.product-form__quantity') || (document.querySelector('quantity-input') && document.querySelector('quantity-input').closest('.product-form__input')) || form;
  anchor.parentNode.insertBefore(box, anchor);

  /* reprendre la moto deja choisie (meme session) */
  try {
    var mem = JSON.parse(sessionStorage.getItem('ih_acc_bike') || 'null');
    if (mem && D.B[mem.m]) { sMake.value = mem.m; fillYears(); sYear.value = String(mem.y); fillModels(); sModel.value = mem.d; }
  } catch (e) {}
  if (!sYear.options.length || sYear.disabled) fillYears(); else apply();

  window.IH_ACC = { version: VERSION, data: D.v, etat: function () { return { make: state.make, year: state.year, model: state.model, allowed: state.allowed, req: state.req, picks: Object.keys(state.picks).map(Number), ref: state.ref, sku: (variantById(currentVariantId()) || {}).sku }; } };
})();
